module.exports = __webpack_public_path__ + "static/media/student-end-season-bg.268ff5a0.jpg";